(function(){
'use strict';
if (window.__sxTry) return; window.__sxTry = 1;
if (window.Shopify && Shopify.designMode) return;
var form = document.querySelector('form[action*="/cart/add"]');
if (!form) return;
var og = document.querySelector('meta[property="og:image"], meta[property="og:image:secure_url"]');
var IMGURL = og ? og.getAttribute('content') : null;
if (!IMGURL) return;
IMGURL = IMGURL.split('?')[0];
var title = (document.querySelector('h1') || {textContent:'SAETTO'}).textContent.trim();
var VIO = '124,77,255';
var ENABLED = false; // trocar para true reativa o try-on completo
function css(t){ var s=document.createElement('style'); s.textContent=t; document.head.appendChild(s); }
css('.sx-try-btn{display:flex;align-items:center;justify-content:center;gap:9px;width:100%;margin-top:12px;padding:13px 20px;background:transparent;border:1px solid rgba('+VIO+',.55);border-radius:8px;color:#5B21D6;font-size:15px;font-weight:600;cursor:pointer;transition:all .2s ease}'+
'.sx-try-btn:hover{background:rgba('+VIO+',.08);box-shadow:0 0 22px rgba('+VIO+',.25)}'+
'.sx-try-btn svg{width:19px;height:19px}'+
'.sx-try-ov{position:fixed;inset:0;z-index:100000;background:rgba(6,6,12,.86);backdrop-filter:blur(4px);display:flex;align-items:center;justify-content:center;padding:18px}'+
'.sx-try-card{position:relative;width:min(480px,94vw);background:#0A0A0E;border:1px solid rgba(255,255,255,.10);border-radius:16px;padding:34px 28px;text-align:center;color:#fff}'+
'.sx-try-card h3{margin:0 0 6px;font-size:22px;color:#fff}'+
'.sx-try-card .sx-k{margin:0 0 18px;color:#B9A0FF;font-size:11px;letter-spacing:.3em;text-transform:uppercase}'+
'.sx-try-card ul{list-style:none;margin:0 0 22px;padding:0;color:#A6ABB8;font-size:14px;line-height:1.9;text-align:left;max-width:330px;margin-inline:auto}'+
'.sx-try-card ul li{padding-left:20px;position:relative}'+
'.sx-try-card ul li:before{content:"";position:absolute;left:2px;top:11px;width:7px;height:7px;border-radius:50%;background:rgb('+VIO+')}'+
'.sx-try-go{width:100%;padding:14px;background:rgb(106,44,255);border:0;border-radius:8px;color:#fff;font-size:15px;font-weight:600;cursor:pointer;margin-bottom:10px}'+
'.sx-try-go:hover{background:rgb('+VIO+')}'+
'.sx-try-no{background:none;border:0;color:#8a8f9b;font-size:13px;cursor:pointer;text-decoration:underline;text-underline-offset:3px}'+
'.sx-try-x{position:absolute;top:10px;right:14px;background:none;border:0;color:#8a8f9b;font-size:25px;cursor:pointer;z-index:5}'+
'.sx-try-x:hover{color:#fff}'+
'.sx-try-stage{position:relative;width:min(560px,94vw);background:#000;border-radius:16px;overflow:hidden;border:1px solid rgba('+VIO+',.35)}'+
'.sx-try-stage video{display:block;width:100%;transform:scaleX(-1)}'+
'.sx-try-stage canvas{position:absolute;inset:0;width:100%;height:100%;pointer-events:none}'+
'.sx-try-bar{position:absolute;left:0;right:0;bottom:0;display:flex;align-items:center;justify-content:space-between;padding:12px 16px;background:linear-gradient(to top,rgba(0,0,0,.72),transparent)}'+
'.sx-try-tt{color:#fff;font-size:13px;letter-spacing:.06em;text-shadow:0 1px 6px rgba(0,0,0,.6)}'+
'.sx-try-snap{background:rgba(255,255,255,.14);border:1px solid rgba(255,255,255,.4);border-radius:999px;color:#fff;font-size:13px;padding:9px 16px;cursor:pointer;backdrop-filter:blur(3px)}'+
'.sx-try-snap:hover{background:rgba('+VIO+',.5)}'+
'.sx-try-load{position:absolute;inset:0;display:flex;flex-direction:column;gap:12px;align-items:center;justify-content:center;color:#cfd3dd;font-size:13px;letter-spacing:.14em;text-transform:uppercase;background:#000;text-align:center;padding:20px}'+
'.sx-try-load i{width:26px;height:26px;border:2px solid rgba('+VIO+',.35);border-top-color:rgb('+VIO+');border-radius:50%;animation:sxspin .8s linear infinite}'+
'@keyframes sxspin{to{transform:rotate(360deg)}}'+
'.sx-try-btn.sx-off{opacity:.62;cursor:not-allowed;filter:saturate(.5)}'+
'.sx-try-btn.sx-off:hover{background:transparent;box-shadow:none}'+
'.sx-try-soon{margin-left:6px;padding:3px 9px;border-radius:999px;background:rgba('+VIO+',.13);color:#6A2CFF;font-size:10px;letter-spacing:.16em;text-transform:uppercase;font-weight:700}');
var btn = document.createElement('button');
btn.type = 'button'; btn.className = 'sx-try-btn';
btn.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M2 12h2m16 0h2M6.5 9h4l1.5 2 1.5-2h4M4 12c0 2.8 1 4.5 3.5 4.5S11 14.8 11 12m2 0c0 2.8 1 4.5 3.5 4.5S20 14.8 20 12c0-2-.5-3-2-3h-3m-11 3c0-2 .5-3 2-3h3"/></svg>' + ((window.__sxT || {}).tryon || 'Try them on');
form.parentNode.insertBefore(btn, form.nextSibling);
if(!ENABLED){ btn.classList.add('sx-off'); btn.setAttribute('aria-disabled','true'); var sn=document.createElement('span'); sn.className='sx-try-soon'; sn.textContent=(window.__sxT || {}).soon || 'Coming soon'; btn.appendChild(sn); }
var glassesImg = null;
function loadGlasses(){ return new Promise(function(res){
  if(glassesImg) return res(glassesImg);
  var im = new Image(); im.crossOrigin='anonymous';
  im.onload = function(){
    try {
      var w = Math.min(900, im.naturalWidth), h = Math.round(im.naturalHeight*w/im.naturalWidth);
      var c = document.createElement('canvas'); c.width=w; c.height=h;
      var x = c.getContext('2d',{willReadFrequently:true});
      x.drawImage(im,0,0,w,h);
      var d = x.getImageData(0,0,w,h), dd=d.data, cs=6, corn=[];
      [[0,0],[w-cs,0],[0,h-cs],[w-cs,h-cs]].forEach(function(o){ for(var yy=0;yy<cs;yy++)for(var xx=0;xx<cs;xx++){ var ii=((o[1]+yy)*w+(o[0]+xx))*4; corn.push(dd[ii],dd[ii+1],dd[ii+2]); } });
      var br=0,bg=0,bb=0,cn=corn.length/3;
      for(var k=0;k<corn.length;k+=3){ br+=corn[k]; bg+=corn[k+1]; bb+=corn[k+2]; } br/=cn; bg/=cn; bb/=cn;
      for(var p=0;p<dd.length;p+=4){ var dr=dd[p]-br, dg=dd[p+1]-bg, db=dd[p+2]-bb; var dist=Math.sqrt(dr*dr+dg*dg+db*db);
        if(dist<=34){ dd[p+3]=0; } else if(dist<58){ dd[p+3]=Math.min(dd[p+3], Math.round(255*(dist-34)/24)); } }
      x.putImageData(d,0,0);
      var colH = new Array(w), xi, yi;
      for(xi=0;xi<w;xi++) colH[xi]=0;
      for(yi=0;yi<h;yi++){ for(xi=0;xi<w;xi++){ if(dd[(yi*w+xi)*4+3]>30) colH[xi]++; } }
      var maxH = 0; for(xi=0;xi<w;xi++) if(colH[xi]>maxH) maxH=colH[xi];
      var thr = maxH*0.40, runs=[], rs=-1;
      for(xi=0;xi<w;xi++){ if(colH[xi]>=thr){ if(rs<0) rs=xi; } else if(rs>=0){ runs.push([rs,xi-1]); rs=-1; } }
      if(rs>=0) runs.push([rs,w-1]);
      var best=null, ri;
      for(ri=0;ri<runs.length;ri++){ if(!best || (runs[ri][1]-runs[ri][0])>(best[1]-best[0])) best=runs[ri]; }
      var minX = best?best[0]:0, maxX = best?best[1]:w-1, minY=h, maxY=0, x3, y3;
      for(y3=0;y3<h;y3++){ for(x3=minX;x3<=maxX;x3++){ if(dd[(y3*w+x3)*4+3]>30){ if(y3<minY)minY=y3; if(y3>maxY)maxY=y3; break; } } }
      if(maxX>minX && maxY>minY){
        var pad=6, cw=Math.min(w,maxX-minX+pad*2), ch=Math.min(h,maxY-minY+pad*2);
        var c2=document.createElement('canvas'); c2.width=cw; c2.height=ch;
        c2.getContext('2d').drawImage(c, Math.max(0,minX-pad), Math.max(0,minY-pad), cw, ch, 0, 0, cw, ch);
        glassesImg = c2;
      } else { glassesImg = c; }
      window.__sxGlassesDim = glassesImg.width+'x'+glassesImg.height;
      res(glassesImg);
    } catch(e){ window.__sxTryErr='px:'+e.message; glassesImg=im; res(im); }
  };
  im.onerror = function(){ res(null); };
  im.src = IMGURL;
}); }
var ov=null, stream=null, lm=null, rafId=0;
function closeAll(){
  if(rafId) cancelAnimationFrame(rafId); rafId=0;
  if(stream){ stream.getTracks().forEach(function(t){t.stop();}); stream=null; }
  if(ov){ ov.remove(); ov=null; }
  document.documentElement.style.overflow='';
}
function consent(){
  ov = document.createElement('div'); ov.className='sx-try-ov';
  ov.innerHTML = '<div class="sx-try-card"><button class="sx-try-x" aria-label="Close">&times;</button>'+
  '<p class="sx-k">Virtual try-on</p><h3>See them on your face</h3>'+
  '<ul><li>Your camera runs only on this device</li><li>Nothing is recorded, uploaded or stored</li><li>Face the light for best tracking</li></ul>'+
  '<button class="sx-try-go">Start camera</button><button class="sx-try-no">Not now</button></div>';
  document.body.appendChild(ov);
  ov.addEventListener('click', function(e){ if(e.target===ov || e.target.closest('.sx-try-x') || e.target.closest('.sx-try-no')) closeAll(); });
  ov.querySelector('.sx-try-go').addEventListener('click', startCam);
}
function startCam(){
  if(!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia){
    var card0 = ov.querySelector('.sx-try-card');
    card0.innerHTML = '<button class="sx-try-x" aria-label="Close">&times;</button><p class="sx-k">Virtual try-on</p><h3>Camera not available here</h3><p style="color:#A6ABB8;font-size:14px;line-height:1.7">This view blocks camera access (preview or in-app browser).<br>Open <b>saetto.com</b> directly in Safari or Chrome and try again.</p>';
    card0.querySelector('.sx-try-x').addEventListener('click', closeAll);
    return;
  }
  var camP = navigator.mediaDevices.getUserMedia({video:{facingMode:'user', width:{ideal:1280}}, audio:false});
  var card = ov.querySelector('.sx-try-card');
  card.outerHTML = '<div class="sx-try-stage"><button class="sx-try-x" aria-label="Close">&times;</button>'+
  '<div class="sx-try-load"><i></i><span>Starting camera</span></div>'+
  '<video playsinline autoplay muted></video><canvas></canvas>'+
  '<div class="sx-try-bar"><span class="sx-try-tt">'+title.replace(/</g,'')+'</span><button class="sx-try-snap">Save photo</button></div></div>';
  ov.querySelector('.sx-try-x').addEventListener('click', closeAll);
  var video = ov.querySelector('video'), cvs = ov.querySelector('canvas'), load = ov.querySelector('.sx-try-load');
  var loadTxt = load.querySelector('span');
  function fail(err){
    window.__sxTryErr = String(err && (err.name+': '+err.message));
    var nm = String(err && err.name || '');
    var msg;
    if(nm.indexOf('NotAllowed')>-1){ msg = 'Camera permission was denied.<br>Allow camera for saetto.com in your browser settings and try again.'; }
    else if(nm.indexOf('NotFound')>-1 || nm.indexOf('Overconstrained')>-1){ msg = 'No front camera was found on this device.'; }
    else { msg = 'Could not start: <br><small style="opacity:.7">'+String(err && (err.name+' - '+err.message)).replace(/</g,'')+'</small>'; }
    load.innerHTML = msg;
  }
  ov.querySelector('.sx-try-snap').addEventListener('click', function(){
    var c=document.createElement('canvas'); c.width=video.videoWidth; c.height=video.videoHeight;
    var x=c.getContext('2d'); x.translate(c.width,0); x.scale(-1,1); x.drawImage(video,0,0);
    x.setTransform(1,0,0,1,0,0); x.drawImage(cvs,0,0,c.width,c.height);
    var a=document.createElement('a'); a.download='saetto-tryon.png'; a.href=c.toDataURL('image/png'); a.click();
  });
  camP.then(function(st){
    stream = st;
    video.srcObject = st;
    var pl = video.play(); if(pl && pl.catch) pl.catch(function(){});
    loadTxt.textContent = 'Loading face tracking';
    return Promise.all([ loadGlasses(), (new Function('u','return import(u)'))('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/+esm') ]);
  }).then(function(r){
    var g2 = r[0], mp = r[1];
    if(!g2) throw new Error('product image failed');
    return mp.FilesetResolver.forVisionTasks('https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14/wasm').then(function(files){
      function make(del){ try { return Promise.resolve(mp.FaceLandmarker.createFromOptions(files, { baseOptions:{ modelAssetPath:'https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task', delegate:del }, runningMode:'VIDEO', numFaces:1 })); } catch(e){ return Promise.reject(e); } }
      return make('GPU').catch(function(){ return make('CPU'); });
    }).then(function(landmarker){
      lm = landmarker;
      load.style.display='none';
      var ctx = cvs.getContext('2d');
      function loop(){
        rafId = requestAnimationFrame(loop);
        if(video.readyState < 2) return;
        if(cvs.width !== video.videoWidth){ cvs.width=video.videoWidth; cvs.height=video.videoHeight; }
        var res2 = lm.detectForVideo(video, performance.now());
        ctx.clearRect(0,0,cvs.width,cvs.height);
        if(!res2 || !res2.faceLandmarks || !res2.faceLandmarks[0]) return;
        var f = res2.faceLandmarks[0];
        var L = f[33], R = f[263], Nn = f[1];
        var W2 = cvs.width, H2 = cvs.height;
        var lx=(1-L.x)*W2, ly=L.y*H2, rx=(1-R.x)*W2, ry=R.y*H2;
        var cx2=(lx+rx)/2, cy2=(ly+ry)/2;
        var nx2=(1-Nn.x)*W2;
        var eyeDist=Math.hypot(rx-lx, ry-ly);
        var ang=Math.atan2(ry-ly, rx-lx);
        var yawShift=(nx2-cx2)*0.5;
        var g2w=eyeDist*2.02;
        var g2h=g2w*(g2.height/g2.width);
        ctx.save();
        ctx.translate(cx2+yawShift, cy2+eyeDist*0.03);
        ctx.rotate(ang);
        ctx.shadowColor='rgba(10,8,20,0.30)'; ctx.shadowBlur=14; ctx.shadowOffsetY=7;
        ctx.drawImage(g2, -g2w/2, -g2h*0.5, g2w, g2h);
        ctx.restore();
      }
      loop();
    });
  }).catch(fail);
}
btn.addEventListener('click', function(){ if(!ENABLED) return; document.documentElement.style.overflow='hidden'; consent(); });
})();